import { MarketingAppResponseDto } from '@tiendanube/common';
import axios from 'App/axios';

export const getMarketingApps = async (): Promise<
  MarketingAppResponseDto[]
> => {
  const response = await axios.get(`v1/marketing-apps`);
  return response.data;
};
